const InvoiceTimingTypeConstants = {
    NumberedDayOfMonth: 0,
    WeeklyDayOfMonth: 1
}

export default InvoiceTimingTypeConstants